import React from 'react';
import { Section } from './Shared';
export const ProblemSolution = () => {
  return <>
      {/* Goals Section */}
      <Section bg="dark" data-id="element-190" data-mp="3qr3ksy671q8h">
        <div className="max-w-3xl mx-auto text-center" data-id="element-191" data-mp="3qtzicle4qcwe">
          <p className="font-montserrat text-sm font-bold uppercase tracking-[0.18em] text-brand mb-4" data-id="element-192" data-mp="3mpi2gxaw4jqw">
            Tus Metas
          </p>
          <h2 className="font-playfair text-3xl md:text-5xl font-bold mb-5" data-id="element-193" data-mp="3ht1eq47ls7ec">
            Tu camino al éxito incluye:
          </h2>
          <p className="font-montserrat text-lg text-gray-300 max-w-2xl mx-auto mb-10" data-id="element-194" data-mp="eaq7jgv7bd5t">
            Un sistema práctico para profesionalizar tu comunicación, valorizar tu trabajo y disfrutar un negocio cada vez más organizado.
          </p>

          <div className="grid grid-cols-1 gap-4 text-left md:grid-cols-3" data-id="element-195" data-mp="4jvkwbe1mbju">
            <div className="rounded-xl border border-white/15 bg-white/5 p-6" data-id="element-196" data-mp="120aqhzrcuaf3">
              <span className="mb-4 flex h-9 w-9 items-center justify-center rounded-full bg-accent text-dark font-bold" data-id="element-197" data-mp="x9lymjbrjbff">✓</span>
              <p className="font-montserrat text-base font-semibold text-base" data-id="element-198" data-mp="6tk7u13qx73m">Scripts de WhatsApp que cierran ventas</p>
            </div>
            <div className="rounded-xl border border-white/15 bg-white/5 p-6" data-id="element-199" data-mp="btq1fmtkt3oc">
              <span className="mb-4 flex h-9 w-9 items-center justify-center rounded-full bg-accent text-dark font-bold" data-id="element-200" data-mp="3u53bwiiwv3ri">✓</span>
              <p className="font-montserrat text-base font-semibold text-base" data-id="element-201" data-mp="1zfzpeiqut0y">Historias que conectan</p>
            </div>
            <div className="rounded-xl border border-white/15 bg-white/5 p-6" data-id="element-202" data-mp="3p68n8zy9ikzh">
              <span className="mb-4 flex h-9 w-9 items-center justify-center rounded-full bg-accent text-dark font-bold" data-id="element-203" data-mp="3p45nho7b5dhk">✓</span>
              <p className="font-montserrat text-base font-semibold text-base" data-id="element-204" data-mp="3f7svcurev7ox">Precios que reflejan tu calidad</p>
            </div>
          </div>

          <p className="mt-10 font-montserrat text-xl font-bold text-brand" data-id="element-205" data-mp="19g5hqla9nvab">
            Todo listo para aplicar desde hoy y disfrutar el crecimiento de tu negocio.
          </p>
        </div>
      </Section>

      {/* Who is it for */}
      <Section bg="mid" data-id="element-206" data-mp="2hf2x79fxfkyq">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-207" data-mp="2hdrtf9mhed7m">
          <div className="bg-base p-8 rounded-xl shadow-sm" data-id="element-208" data-mp="2dcy369lkgmbk">
            <h3 className="font-playfair text-2xl font-bold mb-6 text-dark" data-id="element-209" data-mp="2ddhlvsj1jeqn">
              ✓ Este sistema acompaña tu crecimiento si...
            </h3>
            <ul className="space-y-4 font-montserrat text-gray-700" data-id="element-210" data-mp="354ngjtfzsk8j">
              <li className="flex items-start gap-3" data-id="element-211" data-mp="312sfmq1z48va"><span className="shrink-0 text-accent" data-id="element-212" data-mp="313v6ixzaqbb7">✓</span><span data-id="element-213" data-mp="3156aaxsqrj2b">Sos manicurista, lashista, brow artist, esteticista, cosmetóloga o peluquera.</span></li>
              <li className="flex items-start gap-3" data-id="element-214" data-mp="2rd0jvsi519p8"><span className="shrink-0 text-accent" data-id="element-215" data-mp="2rdsd4wo9ivcc">✓</span><span data-id="element-216" data-mp="2rawhjezw0ir2">Trabajás de forma independiente y valorizás tu talento.</span></li>
              <li className="flex items-start gap-3" data-id="element-217" data-mp="3otpk5hrfw3wi"><span className="shrink-0 text-accent" data-id="element-218" data-mp="3k1y2jwq9h8ii">✓</span><span data-id="element-219" data-mp="3k03focvfj6bs">Usás Instagram y WhatsApp para conectar con nuevas clientas.</span></li>
              <li className="flex items-start gap-3" data-id="element-220" data-mp="3re4aq91zae1g"><span className="shrink-0 text-accent" data-id="element-221" data-mp="3rf5myguqd6kr">✓</span><span data-id="element-222" data-mp="5q8cwqd7xq3">Querés más orden, más consultas y precios que reflejen tu calidad.</span></li>
              <li className="flex items-start gap-3" data-id="element-223" data-mp="55crfmsvk86t"><span className="shrink-0 text-accent" data-id="element-224" data-mp="54b6mqm247bw">✓</span><span data-id="element-225" data-mp="97polmtk2xrz">Disfrutás aplicar herramientas prácticas desde el primer día.</span></li>
            </ul>
          </div>

          <div className="bg-white/50 p-8 rounded-xl border border-brand/20" data-id="element-226" data-mp="e5hq98k05y9d">
            <h3 className="font-playfair text-2xl font-bold mb-6 text-dark" data-id="element-227" data-mp="j4ly9vv6xpy4">
              ✓ Tu próximo paso incluye...
            </h3>
            <ul className="space-y-4 font-montserrat text-gray-700" data-id="element-228" data-mp="nwm1pyagz0zg">
              <li className="flex items-start gap-3" data-id="element-229" data-mp="svgotcfgzbpd"><span className="shrink-0 text-brand" data-id="element-230" data-mp="sudyp6pz1dai">✓</span><span data-id="element-231" data-mp="wxai2znc5dfi">Elegir los scripts ideales para cada conversación.</span></li>
              <li className="flex items-start gap-3" data-id="element-232" data-mp="11vvaicwciste"><span className="shrink-0 text-brand" data-id="element-233" data-mp="11www3bazmxpd">✓</span><span data-id="element-234" data-mp="11tisjzql8igc">Publicar contenido con intención y claridad.</span></li>
              <li className="flex items-start gap-3" data-id="element-235" data-mp="o7lcjjlne0dy"><span className="shrink-0 text-brand" data-id="element-236" data-mp="k7jfjnquxv50">✓</span><span data-id="element-237" data-mp="k6rtp4n2bbrx">Construir una agenda que acompañe tus metas mensuales.</span></li>
            </ul>
          </div>
        </div>
      </Section>

      {/* Solution */}
      <Section bg="base" data-id="element-238" data-mp="szcy1fpy5fx8">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-239" data-mp="t165uycaq66t">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold mb-4 text-dark" data-id="element-240" data-mp="5a0nocivv1tc">
            💅 MEGAKIT MÁS CLIENTAS™
          </h2>
          <p className="font-montserrat text-xl md:text-2xl font-medium text-brand mb-8" data-id="element-241" data-mp="1a0aev7iswnv">
            El sistema listo para usar que te da más clientas, mejores ventas y un negocio organizado.
          </p>
          <div className="font-montserrat text-lg text-gray-700 space-y-4" data-id="element-242" data-mp="a7sibeawx218">
            <p data-id="element-243" data-mp="1qmkbhtfvudbl">
              Herramientas prácticas, ejemplos del rubro y recursos que podés aplicar con claridad desde hoy.
            </p>
            <p className="font-bold text-dark text-xl" data-id="element-244" data-mp="1lqmstgh5cuvn">
              Abrís. Copiás. Aplicás. Disfrutás tus resultados.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden border border-gray-100" data-id="element-245" data-mp="38m1hoqbfrp3z">
          <div className="overflow-x-auto" data-id="element-246" data-mp="2un1tfjru5c8c">
            <table className="w-full text-left font-montserrat" data-id="element-247" data-mp="2zkabzlgwbia4">
              <thead data-id="element-248" data-mp="2zktt4zyq22n3">
                <tr className="bg-mid text-dark" data-id="element-249" data-mp="3na4o20te52tb">
                  <th className="p-4 md:p-6 font-bold w-1/2" data-id="element-250" data-mp="3nbfpvv3a00hs">
                    Tu punto de partida
                  </th>
                  <th className="p-4 md:p-6 font-bold w-1/2 border-l border-white" data-id="element-251" data-mp="3rduaajmlf8b6">
                    Tus herramientas con el Megakit
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-252" data-mp="3ihbkhg9ns0it">
                <tr data-id="element-253" data-mp="a2l4m12gc5uv">
                  <td className="p-4 md:p-6 text-gray-600" data-id="element-254" data-mp="a21o8osg9piy">
                    Improvisás el contenido cada semana
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark border-l border-gray-100 bg-base/50" data-id="element-255" data-mp="oqbc1yifaper">
                    50 scripts de reels listos para grabar
                  </td>
                </tr>
                <tr data-id="element-256" data-mp="ervlpxr7zk6b">
                  <td className="p-4 md:p-6 text-gray-600" data-id="element-257" data-mp="ercepc33yg72">
                    No sabés qué responder por WhatsApp
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark border-l border-gray-100 bg-base/50" data-id="element-258" data-mp="9ssubg45xcgt">
                    Respuestas exactas para cada situación
                  </td>
                </tr>
                <tr data-id="element-259" data-mp="yntq4z88mo3">
                  <td className="p-4 md:p-6 text-gray-600" data-id="element-260" data-mp="3s71r12vzgcsl">
                    No sabés cómo cobrar más
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark border-l border-gray-100 bg-base/50" data-id="element-261" data-mp="3n8qg0otybw8s">
                    Sistema completo para subir precios sin perder clientas
                  </td>
                </tr>
                <tr data-id="element-262" data-mp="3e8k7zih0voh0">
                  <td className="p-4 md:p-6 text-gray-600" data-id="element-263" data-mp="3e9df4kjw8fzo">
                    Tus clientas no vuelven
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark border-l border-gray-100 bg-base/50" data-id="element-264" data-mp="1xqjroto0w8py">
                    Protocolo de re-agendamiento automático
                  </td>
                </tr>
                <tr data-id="element-265" data-mp="27or9feq4yut0">
                  <td className="p-4 md:p-6 text-gray-600" data-id="element-266" data-mp="27ny7qs61avhq">
                    Tu negocio depende del azar
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark border-l border-gray-100 bg-base/50" data-id="element-267" data-mp="1a3283lewwgy2">
                    Planner completo para gestionar todo
                  </td>
                </tr>
                <tr data-id="element-268" data-mp="1jy3tc662gyvd">
                  <td className="p-4 md:p-6 text-gray-600" data-id="element-269" data-mp="1oq541nnl6hja">
                    Creás promos a las corridas
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark border-l border-gray-100 bg-base/50" data-id="element-270" data-mp="rbj69hwmj8xm">
                    30 promos flash listas para publicar
                  </td>
                </tr>
                <tr data-id="element-271" data-mp="3lr4hxhv251rs">
                  <td className="p-4 md:p-6 text-gray-600" data-id="element-272" data-mp="3lsfua62kjhui">
                    Tu feed se ve amateur
                  </td>
                  <td className="p-4 md:p-6 font-medium text-dark border-l border-gray-100 bg-base/50" data-id="element-273" data-mp="3guw7uivpvyrh">
                    Plantillas de Canva listas para editar
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Section>
    </>;
};